<template>
  <hsc-window-style-metal v-if="bundleIndex != undefined">
    <hsc-window  title="" :resizable="true"  :minWidth="250" :minHeight="340" :maxWidth="1190" :maxHeight="800" :closeButton="true" :isOpen.sync="$parent.windowOpen"  positionHint="50 / 150">
       <!--  <div class="minimizeButton" @click="$parent.minimizeWindow"><b>-</b></div> -->
        <bundle ref="window" v-bind:info="$root.app.bundles[bundleIndex]" v-bind:listIndex="rootIndex" :inWindow="true" ></bundle>
    </hsc-window>
  </hsc-window-style-metal>
</template>

<script>

import Bundle from './Bundle.vue'

export default {
  //props: ['bundleIndex', 'importedBreadCrumbs'],
  components: {Bundle},
  data: function(){
    return {
      bundleIndex: null,
      rootIndex: null
    }
  }
}

</script>